import { useTranslation } from "react-i18next";
import { MobileQrCode } from "../mobile/MobileQrCode";
import { androidStoreUrl, iosStoreUrl } from "../../lib/appLinks";
import { assetUrl } from "../../lib/assets";

/** The public download URL must work on a phone even while previewing Web on localhost. */
const DOWNLOAD_URL = "https://muhaha.ai/store-download";

export function DiscoveryDownload() {
	const { t } = useTranslation();
	return <section className="discovery-download" aria-label={t("mobilePlay.getTheApp")}>
		<h2>{t("mobilePlay.getTheApp")}</h2>
		<p>{t("mobilePlay.scanToPlay")}</p>
		<a href={DOWNLOAD_URL} target="_blank" rel="noreferrer" className="discovery-download-qr">
			<MobileQrCode url={DOWNLOAD_URL} size={132} alt={t("mobilePlay.downloadQrAlt")} className="rounded-lg" />
		</a>
		<div className="discovery-store-links">
			<a href={iosStoreUrl()} target="_blank" rel="noreferrer" aria-label={t("mobilePlay.iosStore")} title={t("mobilePlay.iosStore")}>
				<img src={assetUrl("store-badges/apple-mark.svg")} alt="" width={22} height={22} className="discovery-apple-mark" />
			</a>
			<a href={androidStoreUrl()} target="_blank" rel="noreferrer" aria-label={t("mobilePlay.androidStore")} title={t("mobilePlay.androidStore")}>
				<img src={assetUrl("store-badges/google-play-mark.svg")} alt="" width={22} height={22} />
			</a>
		</div>
	</section>;
}
